import Grid from '@mui/material/Grid';
import "./style.css";
import Autocomplete from '@mui/material/Autocomplete';
import React from 'react';
import {useState, useEffect} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CheckIcon from "@mui/icons-material/Check";
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import {readPrivateOffice} from "./apiPO.js";
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { List, ListItem, ListItemText, ListItemIcon, DialogActions } from '@mui/material';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
import axios from 'axios';
import { Phone, Search, } from "@mui/icons-material";
import { IconButton, Checkbox, Box, Typography, TableContainer} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import PhoneInput, { getCountries, getCountryCallingCode, isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css'
import { formatPhoneNumberIntl } from 'react-phone-number-input'
import { formatPhoneNumber } from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
import MenuItem from '@mui/material/MenuItem';
import FormLabel from '@mui/material/FormLabel';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Select, FormControl, InputLabel } from '@mui/material';
import { Table } from 'react-bootstrap';

export default function PaymentDetail({changeStat, contractReq, setContractReq}){
    const [paidDate, setpaidDate] = useState(new Date());
    const [kontrakposts, setKontrakPosts] = useState([])

    const handleDateChange = (date) => {
        setpaidDate(date);
        const piDate = date.getDate();
        const longMonth = date.toLocaleString('default', { month: 'long' });
        const piYear = date.getFullYear();
        console.log(piDate + " " + longMonth + " " + piYear);
    }
    const [error,setError]=useState();
    const [alamatKontrak, setalamatKontrak] = useState("");

    const changetoPaid =() => {
        if(contractReq === "tidak_yakin"){
            changeStat(paidDate)
        }else{
        if(contractReq){
            changeStat(paidDate)
        }else{
            setError("Pilih jawaban diatas")
        }}
    }
    const [names,setNames] = useState([""]);
    const [isEnd,setIsEnd] = useState("Tidak ada pilihan lagi")

const [selectedRooms, setSelectedRooms] = useState("");
    const [statusSambung, setStatusSambung] = useState("");
    const [lokasiSambung, setLokasiSambung] = useState("");
    const [ruanganSambung, setRuanganSambung] = useState("");
    const [key, setKey] = useState(Math.random());
    const [categorias, setCategorias] = useState([]);
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
    const [confirmationPreview, setConfirmationPreview] = useState(false)

    const previewPDF = async (post) => {
        setCurrPreview(post)
        setPreviewVisibility(true)
    }
    const handleSimpanConfirmation = async (post) => {
        setConfirmationPreview(true)
    }
    const handleChangeAddress = (event) => {
        setalamatKontrak(event.target.value)
        const alamatDicari = event.target.value
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/confirm-address`,{
                alamatDicari
        }).then(response=>{
            console.log(response.data)
            setSelectedRooms("")
            setKey(Math.random()); // change the key to force re-rendering
            setNames(response.data.privateOffices)
            console.log(response.data.LokasiSingkatan)
        });
    };
    const [selectedIds, setSelectedIds] = useState([]);
    const handleItemClick = (id) => {
        // Toggle selection
        if (selectedIds.includes(id)) {
            setSelectedIds(selectedIds.filter(itemId => itemId !== id));
        } else {
            setSelectedIds([...selectedIds, id]);
        }
    };
    
    const renderPaymentReminders = () => {
        if (currPreview && currPreview.PaymentReminder) {
            return currPreview.PaymentReminder.map((reminder) => (
                <ListItem
                    key={reminder._id}
                    button={reminder.Stat === ""}
                    onClick={() => reminder.Stat === "" && handleItemClick(reminder._id)}
                    disabled={reminder.Stat !== ""}
                >
                    <ListItemIcon>
                        <Checkbox
                            edge="start"
                            checked={selectedIds.includes(reminder._id)}
                            tabIndex={-1}
                            disableRipple
                        />
                    </ListItemIcon>
                    <ListItemText
                        primary={`Start: ${formatDate(reminder.StartInterval)}, End: ${formatDate(reminder.EndInterval)}`}
                        secondary={reminder.Stat !== "" ? "Paid" : "Belum Paid"}
                    />
                </ListItem>
            ));
        } else {
            return <ListItem><ListItemText primary="No payment reminders available." /></ListItem>;
        }
    };
    const getCategorias = async () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/addressOptions`,{
        }).then(response=>{
          setCategorias(response.data.pilihanAlamat);
      });
        //console.log(res);
      }
      useEffect(() => {
          getCategorias();})
    
    const fetchKontrakPost = async (newValue) => {
        try{
            const { data, error } = await readPrivateOffice(alamatKontrak,newValue,statusSambung);
            if(error){
                console.log(error.message);
                return;
            }
            const yoyo = data.data
            //success
            setKontrakPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
    }
    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
        setSelectedIds([])
    }

    const handleSimpanFix = () => {
        console.log(selectedIds)
        if(selectedIds.length > 0){
            // changeStat(paidDate)
            console.log(currPreview)
            axios.post(`${process.env.REACT_APP_BACKEND_URL}/simpanPOSpecific`,{
                currPreview:currPreview, selectedIds:selectedIds
            }).then(resp => {
                changeStat(paidDate)
            })
           

        }else{
        console.log("harus pilih")}
    }


    // Function to format date
const formatDate = (dateString) => {
    if (!dateString) return 'N/A'; // Return 'N/A' or some default text if dateString is empty
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('id-ID', options);
};

// Function to format currency to Rupiah
const formatRupiah = (number) => {
    if (number == null) return 'N/A'; // Handle null, undefined, or empty
    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR'
    }).format(number);
};
const startDate = formatDate(currPreview.TanggalMulai);
    const endDate = formatDate(currPreview.TanggalBerakhir);
    const grandTotalRupiah = formatRupiah(currPreview.GrandTotal);
    const selectedRoomsString = currPreview.selectedRooms ? currPreview.selectedRooms.join(', ') : 'N/A';

    const handleConfirmationClosePreview = () => {
        setConfirmationPreview(false)
    }
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Dialog
                    open={confirmationPreview}
                    onClose={handleConfirmationClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
            <Grid sx={{p:5}}>
            Apakah Kamu Yakin?
                    <Grid sx={{mt:3}}>
                        <Button variant="contained" color="error" onClick={()=>handleConfirmationClosePreview()}>Cancel</Button>
                    </Grid>
                    <Grid sx={{mt:3}}>
                        <Button variant="contained" color="success" onClick={()=>handleSimpanFix()}>Simpan</Button>
                    </Grid>
            </Grid>
            
                                
        </Dialog>
        <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                        <Typography> Nama Perusahaan: {currPreview.CompanyName}</Typography>
                        <Typography> Nama Klien: {currPreview.KlienNama}</Typography>
                        <Typography> Nominal: {grandTotalRupiah} untuk {currPreview.DurasiKontrak} {currPreview.UnitDurasi}</Typography>
                        <Typography> Tanggal Mulai: {startDate}</Typography>
                        <Typography> Tanggal Berakhir: {endDate}</Typography>
                        <Typography> Lokasi: {currPreview.LokasiKontrak}</Typography>
                        <Typography> Ruangan: {selectedRoomsString}</Typography>
                        <List>
                            {renderPaymentReminders()}
                        </List>


                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="error" onClick={()=>handleClosePreview()}>Cancel</Button>
                        <Button variant="contained" color="success" onClick={()=>handleSimpanConfirmation()}>Simpan</Button>

                    </DialogActions>
                    
                </Dialog>
            <Grid container justifyContent="center" sx={{p:5,}}>
                <Grid item sm={6}>
                    <MobileDatePicker 
                        views={['year', 'month', 'day']}
                        inputFormat="dd/MM/yyyy"
                        label="Tanggal Pembayaran"
                        value={paidDate}
                        onChange={handleDateChange}
                        renderInput={(params) => 
                            <TextField 
                                {...params} 
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <CalendarMonthIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        }
                    />
                </Grid>
                <Grid container sx={{mt:3, mb:3}} justifyContent="center" alignItems="center">
                    <FormControl variant="outlined">
                        <Typography>Apakah Butuh Kontrak?</Typography>
                        <Select
                        labelId="contract-select-label"
                        id="contract-select"
                        value={contractReq}
                        onChange={(event)=>setContractReq(event.target.value)}
                        >
                        <MenuItem value={"tidak_yakin"}>Ini Extent Private Office</MenuItem>
                        <MenuItem value={"ya"}>Ya: Ini VO/PO Baru</MenuItem>
                        <MenuItem value={"ya_extend"}>Ya: Ini Extend Virtual Office</MenuItem>
                        <MenuItem value={"tidak_tipe"}>Tidak: Bukan Kontrak VO/PO</MenuItem>
                        <MenuItem value={"tidak_pelunasan"}>Tidak: Ini adalah Pelunasan</MenuItem>
                        <MenuItem value={"tidak"}>Tidak!</MenuItem>

                        

                        
                        </Select>
                    </FormControl>
                    {contractReq === "tidak_yakin" && (<Grid xs={12} sx={{mt:5}}>
                        Status: 
                        <Select
                        labelId="contract-select-label"
                        id="contract-select"
                        value={statusSambung}
                        onChange={(event)=>{setStatusSambung(event.target.value); setalamatKontrak("");setSelectedRooms("") }}
                        >
                            <MenuItem value={"Aktif"}>Aktif</MenuItem>
                            <MenuItem value={"Expired"}>Expired</MenuItem>
                            <MenuItem value={"Semua"}>Semua</MenuItem>
                        </Select>
        </Grid>
    )}
    {statusSambung !== "" && (<Grid xs={12} sx={{mt:5}}>
                        Lokasi 
                        <Select value={alamatKontrak} whiteSpace="normal" onChange={event => {handleChangeAddress(event);setSelectedRooms("")}}>{categorias.map((categoria) =><MenuItem multiline value={categoria}>{categoria}</MenuItem>)}</Select> 
        </Grid>
    )}
    {alamatKontrak !== "" && (<Grid xs={12} sx={{mt:5}}>
                        Ruangan 
                        <Autocomplete
                                  key={key}
                                  options={names.map(item => item.roomName)}
                                  getOptionLabel={(option) => option}
                                  disableCloseOnSelect
                                  value={selectedRooms}
                                  onChange={(event, newValue) => {
                                    setSelectedRooms(newValue);
                                    fetchKontrakPost(newValue);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      label="Pilih Ruangan Disewa"
                                      placeholder="Pilih Ruangan Disewa"
                                    />
                                  )}
                                  renderOption={(props, option, { selected }) => (
                                    <MenuItem
                                      {...props}
                                      key={option}
                                      value={option}
                                      sx={{ justifyContent: "space-between" }}
                                    >
                                      {option}
                                      {selected ? <CheckIcon color="info" /> : null}
                                    </MenuItem>
                                  )}
                                />

        </Grid>
    )}
    {selectedRooms !== "" && (<Grid xs={12} sx={{mt:5}}>
                        Pilih Kontrak yang mana 
                        <TableContainer sx={{ maxHeight: 300 }} className="min-h-screen h-screen overflow-scroll">
                        <Table>
                        
                            
                            {kontrakposts?.map((post) => (
                                <TableBody>
                                <TableRow hover sx={{ '&:hover': {
                        backgroundColor: '#cceffb !important',
                        },backgroundColor: post.statNotify === 'No' ? 'red' : 'white'}}>
                                        <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                            <p>{post.KlienNama}</p>
                                        </TableCell>
                                        <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                            <p>{post.CompanyName}</p>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            ))}
                            {isEnd}
                            
                        </Table>
</TableContainer>
        </Grid>
    )}
                    </Grid>
                    {error && <Grid className="error_text" sx={12} xs={{mr:2}}>{error}</Grid>}
                        <Grid sx={{pl:5}}>
                        {contractReq !== "tidak_yakin" && contractReq !== "" && (
    <Button variant="contained" onClick={() => changetoPaid()}>
        Done
    </Button>
)}
                
                </Grid>

            </Grid>
            
        </LocalizationProvider>
    );
}